export class Constants {
}
// theme colors
Constants.primaryOrange = "#e55b00";
Constants.lightOrange = "#ff8432";
Constants.mediumOrange = "#f60";
//tables
Constants.templateHeaders = ["Descrizione", "Note", "Tipo", "Operatore", "Ultimo aggiornamento", "Azioni"];
Constants.indemnityHeaders = ["Descrizione", "Note", "Tipo", "Cliente", "Nas id", "Data d'inizio", "Data di fine", "Stato del documento", "Operatore", "Ultimo aggiornamento", "Azioni"];
Constants.orderDirection = ["DESC", "ASC"];
Constants.orderByField = ["lastUpdate", "client", "nasid", "since", "until", "operator"];
